import React from 'react';
import { motion } from 'framer-motion';
import { FlaskConicalIcon, AtomIcon, ZapIcon, BeakerIcon, LeafIcon, LayersIcon, ClipboardCheckIcon, Gamepad2Icon, BookOpenIcon, MonitorPlayIcon, PencilRulerIcon, RefreshCwIcon } from 'lucide-react';
const categories = [{
  label: 'FICHAS VISUALES',
  desc: 'Esquemas, ejemplos y apoyos visuales para explicar contenidos complejos con mayor claridad.',
  icon: AtomIcon,
  accent: 'bg-chem-petrol'
}, {
  label: 'ACTIVIDADES A Y B',
  desc: 'Propuestas listas para practicar, evaluar y recuperar sin repetir exactamente la misma actividad.',
  icon: LayersIcon,
  accent: 'bg-chem-electric'
}, {
  label: 'EVALUACIONES',
  desc: 'Recursos organizados para comprobar avances y acompañar la recuperación de contenidos.',
  icon: ClipboardCheckIcon,
  accent: 'bg-chem-turquoise'
}, {
  label: 'JUEGOS DE QUÍMICA',
  desc: 'Desafíos, clasificaciones, dinámicas participativas y propuestas para repasar de una forma más activa.',
  icon: Gamepad2Icon,
  accent: 'bg-chem-amber'
}, {
  label: 'HISTORIETAS CIENTÍFICAS',
  desc: 'Los Chismes de la Tabla Periódica, Elementos Infieles y recursos que convierten conceptos complejos en historias memorables.',
  icon: BookOpenIcon,
  accent: 'bg-chem-violet'
}];
const moments = [{
  label: 'EXPLICAR',
  desc: 'cuando necesitas que la teoría sea más clara y visual.',
  icon: MonitorPlayIcon
}, {
  label: 'PRACTICAR',
  desc: 'cuando el curso necesita aplicar y afianzar.',
  icon: PencilRulerIcon
}, {
  label: 'EVALUAR',
  desc: 'cuando necesitas comprobar avances sin crear todo nuevamente.',
  icon: ClipboardCheckIcon
}, {
  label: 'RECUPERAR',
  desc: 'cuando un estudiante o grupo necesita otra oportunidad.',
  icon: RefreshCwIcon
}];
const workbooks = [{
  title: 'CUADERNILLO 1 — FUNDAMENTOS DE QUÍMICA Y SISTEMAS MATERIALES',
  desc: 'Materia, propiedades, estados de agregación, modelo de partículas y transformaciones físicas y químicas.',
  icon: FlaskConicalIcon
}, {
  title: 'CUADERNILLO 2 — ESTRUCTURA ATÓMICA Y TABLA PERIÓDICA',
  desc: 'Modelos atómicos, partículas subatómicas, número atómico, número másico, isótopos, iones, tabla periódica y propiedades periódicas.',
  icon: AtomIcon
}, {
  title: 'CUADERNILLO 3 — CONFIGURACIÓN ELECTRÓNICA Y ENLACES QUÍMICOS',
  desc: 'Distribución electrónica, bloques de la tabla periódica, enlaces iónicos, covalentes y metálicos, y estructuras de Lewis.',
  icon: ZapIcon
}, {
  title: 'CUADERNILLO 4 — QUÍMICA INORGÁNICA Y REACCIONES',
  desc: 'Números de oxidación, formulación, nomenclatura, compuestos inorgánicos, reacciones químicas, balanceo y estequiometría.',
  icon: BeakerIcon
}, {
  title: 'CUADERNILLO 5 — QUÍMICA ORGÁNICA, SALUD Y AMBIENTE',
  desc: 'Carbono, hidrocarburos, grupos funcionales, polímeros, bioquímica básica, salud y química ambiental.',
  icon: LeafIcon
}];
export function ProductBreakdown() {
  return <section className="py-8 md:py-16 px-4" data-id="element-196" data-mp="3l21ip5ulr8a">
      <div className="max-w-6xl mx-auto" data-id="element-197" data-mp="3jqxqpcekjh6">
        <div className="text-center mb-7 md:mb-12 max-w-4xl mx-auto" data-id="element-198" data-mp="3lqnczzc6xxuc">
          <div className="inline-flex items-center gap-2 text-chem-petrol font-black tracking-widest text-xs md:text-sm uppercase mb-4" data-id="element-199" data-mp="3lqdm89jbnmnl">
            <FlaskConicalIcon size={16} data-id="element-200" data-mp="3c13syqcqrxxw" />
            <span data-id="element-201" data-mp="3c026lpq9zp0v">Biblioteca Química Visual</span>
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-chem-navy mb-4 leading-tight" data-id="element-202" data-mp="3gs3phuhy8dzv">
            No compras cinco cuadernillos.{' '}
            <span className="text-chem-electric" data-id="element-203" data-mp="331qhjs524zaj">
              Accedes a una biblioteca de recursos que resuelve tus clases.
            </span>
          </h2>
          <p className="text-chem-navy/70 font-bold text-sm md:text-lg leading-relaxed" data-id="element-204" data-mp="2t1g4c7j0vrvd">
            El corazón de Química Visual son los materiales listos para imprimir
            y usar. Elige el tema, toma el recurso que necesitas y entra a clase
            con una propuesta clara.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-10 md:mb-16" data-id="element-205" data-mp="8k9iv8xixx2">
          {categories.map((category, i) => {
          const Icon = category.icon;
          const isFeature = i === 0;
          return <motion.article key={category.label} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.06
          }} className={`bg-white border border-chem-petrol/12 rounded-3xl p-5 md:p-7 shadow-lg shadow-chem-navy/5 flex flex-col ${isFeature ? 'lg:col-span-2' : ''}`} data-id="element-206" data-mp="3ml9cq5cfpzcn" data-mpi={i}>
                <span className={`${category.accent} inline-flex items-center justify-center w-11 h-11 md:w-12 md:h-12 rounded-2xl text-white mb-4`} data-id="element-207" data-mp="16v6co677k1uv">
                  <Icon className="w-5 h-5 md:w-6 md:h-6" strokeWidth={2.2} data-id="element-208" data-mp="19fulfywjveuy" />
                </span>
                <h3 className={`font-black text-chem-navy uppercase tracking-tight leading-tight mb-2 ${isFeature ? 'text-lg md:text-2xl' : 'text-base md:text-lg'}`} data-id="element-209" data-mp="1edw3cgi8p84u">
                  {category.label}
                </h3>
                <p className="text-chem-navy/65 font-medium text-sm md:text-base leading-relaxed" data-id="element-210" data-mp="qj2tl12xzrfa">
                  {category.desc}
                </p>
              </motion.article>;
        })}
        </div>

        <div className="bg-chem-navy rounded-[2rem] p-6 md:p-10 mb-10 md:mb-16" data-id="element-211" data-mp="10hscmx6krhx4">
          <h3 className="text-white font-black text-xl md:text-3xl text-center leading-tight mb-6 md:mb-8" data-id="element-212" data-mp="14iud1hc8a00o">
            Recursos para cada momento real del aula
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-id="element-213" data-mp="2fver4y12nf4h">
            {moments.map((moment, i) => {
            const Icon = moment.icon;
            return <motion.div key={moment.label} initial={{
              opacity: 0,
              y: 14
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.06
            }} className="rounded-2xl bg-white/5 border border-white/10 p-5 flex flex-col" data-id="element-214" data-mp="brjvp0njdpzq" data-mpi={i}>
                  <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-chem-turquoise/15 text-chem-turquoise mb-4" data-id="element-215" data-mp="3p7riarzws1c6">
                    <Icon className="w-5 h-5" strokeWidth={2.2} data-id="element-216" data-mp="6v35m0ws11k0" />
                  </span>
                  <p className="text-chem-turquoise font-black text-sm md:text-base tracking-wide mb-1" data-id="element-217" data-mp="220dlx7ne05x">
                    {moment.label}
                  </p>
                  <p className="text-white/70 font-medium text-sm leading-relaxed" data-id="element-218" data-mp="35jsclvk7bkdm">
                    {moment.desc}
                  </p>
                </motion.div>;
          })}
          </div>
        </div>

        {/* Workbooks: high-value extra, deliberately secondary */}
        <div className="border-t border-chem-petrol/15 pt-8 md:pt-12" data-id="element-219" data-mp="1c11p6ra52j60">
          <div className="max-w-3xl mx-auto text-center mb-6 md:mb-8" data-id="element-220" data-mp="1byp0zwdsfcki">
            <span className="inline-flex items-center gap-2 rounded-full bg-chem-amber px-3 py-1 text-[10px] md:text-xs font-black text-chem-navy uppercase tracking-widest mb-4" data-id="element-221" data-mp="1h0o0uwabjrcp">
              Incluidos sin costo adicional
            </span>
            <h3 className="text-xl md:text-3xl font-black text-chem-navy leading-tight mb-3" data-id="element-222" data-mp="1ur9pl1mgevii">
              Y además, recibes sin costo adicional los 5 cuadernillos visuales
              de apoyo.
            </h3>
            <p className="text-chem-navy/65 font-medium text-sm md:text-base leading-relaxed" data-id="element-223" data-mp="jce2qsdnlnqv">
              Porque, además de tener recursos listos para resolver tus clases,
              también necesitas una guía ordenada para recorrer los contenidos
              durante el año.
            </p>
          </div>

          <ul className="space-y-2.5 md:space-y-3 max-w-4xl mx-auto" data-id="element-224" data-mp="1azfnb4dzuqce">
            {workbooks.map((workbook, i) => {
            const Icon = workbook.icon;
            return <motion.li key={workbook.title} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.05
            }} className="bg-white/60 border border-chem-petrol/12 rounded-2xl px-4 py-4 md:px-5 flex gap-3 md:gap-4 items-start" data-id="element-225" data-mp="112197bfjmdn9" data-mpi={i}>
                  <span className="shrink-0 inline-flex items-center justify-center w-9 h-9 rounded-xl bg-chem-ice text-chem-petrol" data-id="element-226" data-mp="1k15cs4obff7j">
                    <Icon className="w-4 h-4" strokeWidth={2.2} data-id="element-227" data-mp="2hh2jeonkylr6" />
                  </span>
                  <div data-id="element-228" data-mp="2cnhurn7vn44n">
                    <h4 className="font-black text-chem-navy/85 text-xs md:text-sm leading-tight mb-1 uppercase tracking-tight" data-id="element-229" data-mp="2cn80vojpocto">
                      {workbook.title}
                    </h4>
                    <p className="text-chem-navy/60 text-xs md:text-sm leading-relaxed font-medium" data-id="element-230" data-mp="2p1d4mokxfaz0">
                      {workbook.desc}
                    </p>
                  </div>
                </motion.li>;
          })}
          </ul>

          <p className="text-center text-chem-petrol font-black text-base md:text-xl leading-snug max-w-3xl mx-auto mt-6 md:mt-8" data-id="element-231" data-mp="33vhzl730anam">
            Los cuadernillos te ayudan a ordenar el año. Los recursos te ayudan
            a resolver la clase de hoy.
          </p>
        </div>
      </div>
    </section>;
}